import { Subject } from 'rxjs';
import type { Navigator } from './Navigator.js';
import { routes } from '../navigation/routes.js';

/**
 * Coordinator raíz (app web-client): único dueño de `route$` y única
 * implementación de `Navigator`. Ver doc en la versión de web-admin.
 */
export class AppCoordinator implements Navigator {
  readonly route$ = new Subject<string>();

  go(path: string): void {
    this.route$.next(path);
  }

  goToHome(): void {
    this.go(routes.home());
  }

  /** @deprecated usá `goToHome()`. */
  goToClientHome(): void {
    this.goToHome();
  }
}

export const appCoordinator = new AppCoordinator();
